import axios from 'axios'
import _get from 'lodash/get'

import config from '../config'
import { ERROR_CODE_POSTCODE_LOOKUP_NOT_FOUND, ERROR_MESSAGE_SAVING } from '../constants'
import { sendApiErrorsToSentry } from '../helpers/sentry'
import { handleRequestError } from './request'

export const CREATE_USER_ADDRESS = 'CREATE_USER_ADDRESS'
export const RECEIVE_USER_ADDRESSES = 'RECEIVE_USER_ADDRESSES'
export const REQUEST_USER_ADDRESSES = 'REQUEST_USER_ADDRESSES'
export const SAVE_USER_ADDRESS = 'SAVE_USER_ADDRESS'

export const requestUserAddresses = () => (dispatch) => {
    dispatch({ type: REQUEST_USER_ADDRESSES })

    axios
        .get('/useraddresses')
        .then((response) => {
            const items = _get(response, ['data'], [])
            dispatch(receiveUserAddresses({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveUserAddresses({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveUserAddresses({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveUserAddresses = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_USER_ADDRESSES, data })
}

export const updateOrCreateUserAddress = (data) => (dispatch) => {
    if (data.id) {
        return dispatch(saveUserAddress(data))
    }

    return dispatch(createUserAddress(data))
}

export const saveUserAddress = (data) => (dispatch) => {
    dispatch({ type: SAVE_USER_ADDRESS, data })

    const { id } = data

    return axios
        .put(`/useraddresses/${id}`, data)
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveUserAddresses({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const createUserAddress = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_USER_ADDRESS, data })

    const { profile } = getState()
    const { id: userId } = profile

    return axios
        .post('/useraddresses', { ...data, userId })
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveUserAddresses({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const requestPostcodeLookup = (postcode) => () =>
    axios
        .get(`https://api.ideal-postcodes.co.uk/v1/postcodes/${postcode}?api_key=${config.idealPostCodesApiKey}`)
        .then((response) => {
            const addresses = _get(response, ['data', 'result'], [])
            return addresses
        })
        .catch((error) => {
            const errorCode = _get(error, ['response', 'data', 'code'])

            const isCommonError = [ERROR_CODE_POSTCODE_LOOKUP_NOT_FOUND].includes(errorCode)

            if (!isCommonError) {
                sendApiErrorsToSentry(error)
            }

            return Promise.reject(error)
        })
